import React from "react";

import { useAppSelector } from "store";
import { selectOptimisedSalesMix } from "modules/customer/tools/product/storeOpportunities/storeOpportunitiesSlice";
import SalesMixTreemap from "./SalesMixTreemap";
import { Box, Typography } from "@material-ui/core";

const OptimisedSalesMix: React.FC = () => {
    const { isLoading, hasErrors, data } = useAppSelector(selectOptimisedSalesMix);

    return (
        <Box data-cy="optimised-sales-mix-treemap">
            <Typography variant="h6" component="div" gutterBottom>
                Optimised sales mix
            </Typography>
            <SalesMixTreemap
                isLoading={isLoading}
                hasErrors={hasErrors}
                salesTypeName="Optimised"
                data={data}
            />
        </Box>
    );
};

export default OptimisedSalesMix;
